export default __webpack_public_path__ + "static/media/Tutorial-Step-6.1a1cf187.jpg";